'use es6';

import { Map as ImmutableMap } from 'immutable';
import { handleActions } from 'flux-actions';
import LoginRecommend from '../constants/LoginRecommend';
import { LoginRequirementActionTypes } from '../actions/loginRequirementActions';
import { RequestStates } from '../constants/RequestStates';
import { SsoLoginActionTypes } from '../actions/ssoLogin';
const initialState = new ImmutableMap({
  stagedEmail: '',
  stagedRememberLogin: false,
  loginRequirementRequestStatus: RequestStates.UNATTEMPTED,
  loginRequirement: ImmutableMap({
    loginType: LoginRecommend.HUBSPOT,
    hardRequirement: false
  }),
  hasSsoRequirement: false,
  useDark: false,
  loginRedirectUrl: undefined,
  allowFbSignup: false,
  hideSignupLink: false,
  signupParams: undefined,
  pageId: undefined,
  ssoError: ''
});
export default handleActions({
  [LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_BEGIN](state) {
    return state.merge({
      loginRequirementRequestStatus: RequestStates.REQUESTING
    });
  },

  [LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_SUCCESS](state, action) {
    return state.merge({
      stagedEmail: action.payload.get('stagedEmail'),
      stagedRememberLogin: action.payload.get('stagedRememberLogin'),
      loginRequirement: ImmutableMap(action.payload.get('loginRequirement')),
      hasSsoRequirement: action.payload.get('hasSsoRequirement'),
      loginRequirementRequestStatus: RequestStates.SUCCEEDED,
      useDark: action.payload.get('useDark'),
      loginRedirectUrl: action.payload.get('loginRedirectUrl'),
      allowFbSignup: action.payload.get('allowFbSignup'),
      hideSignupLink: action.payload.get('hideSignupLink'),
      signupParams: action.payload.get('signupParams'),
      pageId: action.payload.get('pageId')
    });
  },

  [LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_FAILURE](state) {
    return state.merge({
      loginRequirement: ImmutableMap({
        loginType: LoginRecommend.HUBSPOT,
        hardRequirement: false
      }),
      isHardRequirement: false,
      hasSsoRequirement: false,
      loginRequirementRequestStatus: RequestStates.FAILED,
      useDark: false,
      loginRedirectUrl: undefined,
      allowFbSignup: false,
      hideSignupLink: false,
      signupParams: undefined,
      pageId: undefined
    });
  },

  [SsoLoginActionTypes.SSO_LOGIN_FAILURE](state, action) {
    return state.merge({
      ssoError: action.error
    });
  }

}, initialState);